import ss from '@/utils/session-storage';

const bikeReport = {
  namespaced: true,
  state: {
    reportNotify: 0,
    // 暫時
    createReport: ss.getItem('createReport')
  },
  mutations: {
    setCreateReport (state, data) {
      ss.setItem('createReport', data);
      state.createReport = ss.getItem('createReport');
    }
  },
  actions: {
    setCreateReport ({ commit }, data) {
      commit('setCreateReport', data);
    }
  },
  getters: {
    getReportNotify: state => state.reportNotify,
    getReportData: state => state.createReport
  }
};

export default bikeReport;
